// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { PracticePayPracticeLocationListResponse } from './practice-pay-practice-location-list-response';

/** See com.rev360.pms.api.controller.admin.solutions.practicepay.PracticePayPracticeLocationsResponse */
/* istanbul ignore next */
@GandalfModel
export class PracticePayPracticeLocationsResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Boolean })
	hasOtherActiveExternalSystem!: boolean;

	@GandalfArray(PracticePayPracticeLocationListResponse)
	practicePayPracticeLocationListResponses!: PracticePayPracticeLocationListResponse[];

}
